import type { BubbleProps } from '@/features/Bubble/types'
import {
  close,
  hidePreviewMessage,
  open,
  setInputValue,
  setPrefilledVariables,
  showPreviewMessage,
  toggle,
  unmount,
} from '@/features/Commands'

export function initBubble(props: BubbleProps) {
  const bubbleElement = document.createElement('beeetle-bubble')
  Object.assign(bubbleElement, props)
  document.body.append(bubbleElement)
}

interface BeeetleBot {
  initBubble: typeof initBubble
  close: typeof close
  hidePreviewMessage: typeof hidePreviewMessage
  open: typeof open
  setPrefilledVariables: typeof setPrefilledVariables
  showPreviewMessage: typeof showPreviewMessage
  toggle: typeof toggle
  setInputValue: typeof setInputValue
  unmount: typeof unmount
}

declare const window:
  | {
    BeeetleBot: BeeetleBot | undefined
  }
  | undefined

export function parseBeeetleBot() {
  return {
    initBubble,
    close,
    hidePreviewMessage,
    open,
    setPrefilledVariables,
    showPreviewMessage,
    toggle,
    setInputValue,
    unmount,
  }
}

export function injectBeeetleBotInWindow(beeetleBot: BeeetleBot) {
  if (typeof window === 'undefined')
    return
  window.BeeetleBot = { ...beeetleBot }
}
